<template>
  <qb-sidebar
    :name="name"
    :title="data.entry_id + ' | ' + data.client_name | upperCase"
    :bgColor="data.status_color != '#ffffff                  '? data.status_color  : '#626262'"
    textColor="#fff"
    size="lg"
    :loading="loading.details || loading.containers || loading.files|| loading.invoiceList || loading.reviewOrder || loading.loadOrder || loading.comments"
    @open="open"
  >
    <template v-slot:header>
      <vs-row vs-justify="center" class="px-4 mb-4 f-14">
        <vs-col vs-type="flex" vs-w="12" class="mt-2">
          <p>
            <strong> {{ $t('updated') | capitalize }} : </strong>
            {{ formatDate(data.updated_at) }}
           
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            <strong>{{ $tc('created_by', 1) | capitalize }} : </strong>
            {{ data.created_by_name| capitalize }}
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
           <strong>{{ $tc('warehouse') | capitalize }} : </strong>
            {{ data.warehouse_name | capitalize }}
          
          </p>
        </vs-col>
      </vs-row>
      <vs-row vs-justify="flex-end" class="p-4 mb-4">
        <vs-col vs-type="flex" vs-xs="12" vs-sm="4" vs-lg="4">
          <qb-status-card
            :textColor="data.status_color != '#ffffff                  '? data.status_color  : '#626262'"
            :text="data.status_name"
          />
        </vs-col>
      </vs-row>
    </template>
    <vs-row vs-justify="flex-center" class="px-4 mb-4"> </vs-row>
    <vs-row vs-justify="flex-center" class="px-4 mb-4">
        <vs-col vs-xs="12" vs-sm="8" vs-lg="8">
            <table>
            <tr>
                <td class="font-medium"><strong>{{ $t('provider') | capitalize }}: </strong></td>
                <td>{{ data.vendor_name || '' }}</td>
            </tr>
            <tr>
                <td class="font-medium"><strong>{{ $t('carrier') | capitalize }}: </strong></td>
                <td>{{ data.transporter_name || '' }}</td>
            </tr>
            <tr>
                <td class="font-medium"><strong>{{ $t('client') | capitalize }}: </strong></td>
                <td>{{ data.client_name || '' }}</td>
            </tr>
            <tr>
                <td class="font-medium"><strong>{{ $t('tracking') | capitalize }}: </strong></td>
                <td>{{ data.tracking_number || ''}}</td>
            </tr>
            <tr>
                <td class="font-medium"><strong>{{ $t('destination') | capitalize }}: </strong></td>
                <td>{{ data.destination || '' }}</td>
            </tr>
            <tr>
                <td class="font-medium"><strong>{{ $tc('po_number') | capitalize }}: </strong></td>
                <td> {{ data.PO_number || '' }}</td>
            </tr>
            <tr>
                <td class="font-medium"><strong>{{ $t('damaged') | capitalize }}: </strong></td>
                <td> {{ (data.is_damage == "0") ? 'no':'si' }}</td>
            </tr>
            </table>
            
      </vs-col>
      <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
          <p class="font-medium"><strong>{{ $t('comments') | capitalize }}: </strong></p>
          <p>{{ data.comments || '' }}</p>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="flex-center" class="px-4 mb-4 f-14">
      <vs-col vs-w="12" class="mt-1">
        <vs-row>
          <vs-col vs-xs="12" vs-sm="8"  vs-lg="8" vs-type="flex" vs-align="center" class="mb-4">
              <feather-icon icon="PackageIcon" class="mx-1  card-header-icon" />
              <h4>
              | {{ $tc('container', 2) | capitalize }} |
              {{ $t('quantity') | capitalize }}:
              {{ entryContainers.length }} |
              {{ data.weight }}
              {{ data.weight_unit }}
              </h4>
          </vs-col>

          <vs-col
              vs-xs="6" vs-sm="2"  vs-lg="2"
              vs-type="flex"
              class="mb-4"
          >   
              <vs-button @click="redirectShowQR" color="dark" type="flat">
                <feather-icon icon="GridIcon" class=" inline-block align-middle"></feather-icon>
                <span class="inline-block align-middle ml-4">Show QR</span>
              </vs-button>  
            </vs-col>
          <!-- <vs-col
              vs-xs="6" vs-sm="2"  vs-lg="2"
              vs-type="flex"
              class="mb-4"
              vs-justify="flex-end"
              vs-align="center"
          >       
              <vs-button @click="redirectPrintQR"  color="dark" type="flat">  
                <feather-icon icon="GridIcon" class=" inline-block align-middle"></feather-icon>
                <span class="inline-block  align-middle ml-4">Print QR</span>   
              </vs-button>       
          </vs-col> -->
        </vs-row>
             
              <vs-tabs>
                <vs-tab
                  :label="$tc('container', 2) | capitalize"
                  icon-pack="feather"
                  icon="icon-box"
                >
                  <div class="tab-text">
                    <entry-containers :data="entryContainers" @containerUpdated="containerUpdated" :entryId="entriId"/>
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$t('files') | capitalize"
                  icon-pack="feather"
                  icon="icon-image"
                  :disabled="entryFiles.length === 0"
                >
                  <div class="tab-text">
                    <file-list :data="entryFiles" />
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$t('no_part') | capitalize"
                  icon-pack="feather"
                  icon="icon-layers"
                  :disabled="entryInvoiceList.length === 0"
                >
                  <div class="tab-text">
                    <entry-parts :data="entryInvoiceList" />
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$tc('review_order',2) | capitalize"
                  icon-pack="feather"
                  icon="icon-check-square"
                  :disabled="entryReviewOrder.length === 0"
                >
                  <div class="tab-text">
                    <entry-review-order :data="entryReviewOrder" />
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$t('load_order') | capitalize"
                  icon-pack="feather"
                  icon="icon-truck"
                  :disabled="entryLoadOrder.length === 0"
                >
                  <div class="tab-text">
                    <entry-load-order :data="entryLoadOrder" />
                  </div>
                </vs-tab>
              </vs-tabs>
          </vs-col>
            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-2">
                <div  class="display-flex">
                    <vs-row>
                    <vs-col vs-w="8" vs-type="flex">
                        <feather-icon icon="ClockIcon" class="mx-1 icon-title" />
                        <h4 class="mt-3">{{ $t('timeline') | capitalize }}</h4>
                    </vs-col>

                    </vs-row>
                </div>
                <timeline :data="timeline" />
            </vs-col>
    </vs-row>
  </qb-sidebar>
</template>
<script>
import QbSidebar from '@/views/qb-components/QbSidebar'
import QbStatusCard from '@/views/qb-components/QbStatusCard'
import EntryContainers from './components/EntryContainers.vue'
import EntryFiles from './components/EntryFiles.vue'
import EntryParts from './components/EntryParts.vue'
import Timeline from '@/views/components/Timeline.vue'
import EntryReviewOrder from './components/EntryReviewOrder.vue'
import EntryLoadOrder from './components/EntryLoadOrder.vue'
import dashboard from '@/http/requests/dashboard'
import moment from 'moment'
import FileList from '@/views/components/FileList.vue'
import { BASE_URL } from '@/urls.js'
export default {
  name: 'ehs-details',
  components: {
    QbSidebar,
    QbStatusCard,
    EntryContainers,
    EntryFiles,
    EntryParts,
    Timeline,
    EntryReviewOrder,
    EntryLoadOrder,
    FileList,
    dashboard
  },
  props: {
    entriId:{
        type: String,
    }
  },
  data() {
    return {
      name: 'sidebar-entri-details',
      data: {},
      timeline:[],
      entryContainers: [],
      entryFiles: [],
      entryInvoiceList: [],
      entryReviewOrder: [],
      entryLoadOrder: [],
      loading: {
        details: false,
        containers: false,
        files: false,
        invoiceList: false,
        reviewOrder: false,
        loadOrder: false,
        comments: false
      },
      disabledSubmitButton:false,
      confirmActive: false,
      confirmActiveLock: false,
      submitButtonText: this.$i18n.messages[this.$i18n.locale].save
    }
    
  },
  methods: {
    open() {
        this.getDetails()
        this.getContainers()
        this.getFiles()
        this.getInvoiceList()
        this.getReviewOrder()
        this.getLoadOrder()
        this.getComments()
    },
    reload () {
      this.getFiles()
      this.getDetails()
    },
    getDetails () {
      this.loading.details = true
      dashboard
        .showEntrie(this.entriId) //FUNKA 27
        .then((res) => {
          this.data = Object.assign({}, res.data.data)
          this.loading.details = false
        })
        .catch((res) => {
          this.loading.details = false
        })
    },
    getContainers () {
      this.loading.containers = true
      dashboard
        .getContainers(this.entriId) //FUNKA 27
        .then((res) => {
          this.entryContainers = [...res.data.data]
          this.loading.containers = false
        })
        .catch((res) => {
          this.loading.containers = false
        })
    },
    getFiles () {
      this.loading.files = true
      dashboard
        .getEntrieFiles(this.entriId) //FUNKA 27
        .then((res) => {
          this.entryFiles = [...res.data.data]
          this.loading.files = false
        })
        .catch((res) => {
          this.loading.files = false
        })
    },
    getInvoiceList () {
      this.loading.invoiceList = true
      dashboard
        .getInvoiceList(this.entriId) //FUNKA 27
        .then((res) => {
          this.entryInvoiceList = [...res.data.data]
          this.loading.invoiceList = false
        })
        .catch((res) => {
          this.loading.invoiceList = false
        })
    },
    getReviewOrder () {
      this.loading.reviewOrder = true
      dashboard
        .getReviewOrder(this.entriId)
        .then((res) => {
          this.entryReviewOrder = [...res.data.data]
          this.loading.reviewOrder = false
        })
        .catch((res) => {
          this.loading.reviewOrder = false
        })
    },
    getLoadOrder () {
      this.loading.loadOrder = true
      dashboard
        .getLoadOrder(this.entriId)
        .then((res) => {
          this.entryLoadOrder = [...res.data.data]
          this.loading.loadOrder = false
        })
        .catch((res) => {
          this.loading.loadOrder = false
        })
    },
    getComments () {
      this.loading.comments = true
      dashboard.timeline(this.entriId)
        .then((res) => {
          this.timeline = [...res.data.data]
          this.loading.comments = false
        })
        .catch((res) => {
          this.loading.comments = false
        })
    },
    addComment (data) {
      this.timeline.unshift(data)
    },
    inventaryEntry () {
      this.confirmActive = true
    },
    lockEntry () {
      this.confirmActiveLock = true
    },
    containerUpdated () {
      this.getContainers()
    },
    redirectShowQR(){
      window.open(BASE_URL+'internal_api/entries/show_qr/'+this.entriId, '_blank');
    },
    redirectPrintQR () {
      window.open(`${BASE_URL}qrprint/print_qr_printer?entry_id=${this.entriId}`, '_blank')
    }
  },
  mounted() {
  }
}
</script>

<style>
.display-flex {
  display: flex;
}
</style>
